export default __webpack_public_path__ + "static/media/green_tick.6ae0f192.svg";